jQuery(document).ready(function () {
    
    if(jQuery('.ride-filters').length) {
        const urlParams = new URLSearchParams(window.location.search);
        const filterParam = urlParams.get("ride_filter");

        if (filterParam) {
            const filterArray = [filterParam];
            filterSelected(filterArray);
            jQuery("input[type=checkbox][value="+filterParam+"]").prop("checked", true);
        }

        jQuery('[name="rideFilter"]').change(function() {
            // get all the checked value to operate the filter
            let selectedCategories = [];
            jQuery.each(jQuery('input[name="rideFilter"]:checked'), function(){
                selectedCategories.push(this.value);
            });
            filterSelected(selectedCategories);
        });
        
        function filterSelected (selectedCategories) {
            // loop the ride listing
            jQuery('.rides-listing a').hide();
            jQuery('.rides-listing a').filter(function(){
                // conditionally check if the all rides is selected or if selectedCategories is empty
                if(selectedCategories.includes('all') || selectedCategories.length === 0) return true;
                // check the data value against the selectedCategories array
                // rides can be in more that one category so implode the category data to an array
                const rideListingCategories = jQuery(this).data("category").split(' ');
                let isInSelection = false;
                rideListingCategories.forEach(category => {
                    if (selectedCategories.includes(category)){
                        isInSelection = true;
                    }
                });
                // are any of the rideCategories in the selectedCategories
                return isInSelection;
            }).show();
        }
        // show hide mobile view
        jQuery('.ride-filters__mobile-toggle').click(function(){
            jQuery('.ride-filters__content-wrapper').toggle();
            jQuery('.ride-filters__mobile-toggle').toggleClass('filter-open');
        });
        //
        const desktopMedia = window.matchMedia('(min-width: 992px)');
        desktopMedia.addEventListener("change", resetMobileFilters);
        //
        // handle screen size changes
        function resetMobileFilters(desktopMedia){
            if (desktopMedia.matches) {
                jQuery('.ride-filters__content-wrapper').show();
            } else {
                jQuery('.ride-filters__content-wrapper').hide();
                jQuery('.ride-filters__mobile-toggle').removeClass('filter-open');
            }
        }
    }
});